import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { orderBy } from 'lodash';
import { ReplaySubject, firstValueFrom, map, tap } from 'rxjs';
import { AppError } from './app-error.type';

@Injectable({
    providedIn: 'root'
})
export class AppErrorsService {
    
    errors$ = new ReplaySubject<AppError[]>(1);
    appErrorsNumber$ = new ReplaySubject<number>(1);

    constructor(private http: HttpClient) { }

    async query() {
        return await firstValueFrom(this.http.get<AppError[]>(`/admin/apperrors/`).pipe(
            map(errors => orderBy(errors, ['received_at'], ['desc'])),
            tap(errors => {
                this.appErrorsNumber$.next(errors.length);
                this.errors$.next(errors);
            })
        ));
    }

    async removeError(errorIds: string[]){
        return await firstValueFrom(this.http.delete('/admin/apperrors/', {
            body: errorIds
        }));
    }
}